import React, { useContext, useState, useEffect } from "react";
import { Box, Typography, Menu, MenuItem, Button } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import "../../cssfiles/homepage.css";
import { ThemeContext } from "../Homepage";
import LK_Add from "../../images/LK_Add";
import CustomButton from "../CommonComponents/CustomButton";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomCheckbox from "../CommonComponents/CustomCheckbox";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Divider from "@mui/material/Divider";
import LK_Delete from "../../images/LK_Delete";
import LK_Select from "../../images/LK_Select";
import LK_Close from "../../images/LK_Close";
import LK_Search from "../../images/LK_Search";
import CustomRadioButton from "../CommonComponents/CustomRadioButton";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import LK_Refresh from "../../images/LK_Refresh";
import LK_Loading from "../../images/LK_Loading.gif";
import CustomToast from "../CommonComponents/CustomToast";
import CustomTooltip from "../CommonComponents/CustomTooltip";
import {
  devicelibrarycreate,
  getlibrarydevices,
  librarydevicedelete,
  getDeviceTypesList,
  getTagUnitsandDataTypes,
  getStorageGroupsList,
} from "../../Restclient/datacollection";
import EditableTableLibrary from "../Dashboards/Graphs/Table/EditableTableLibrary";

export default function DeviceLibrary() {
  const filter = [
    "Status Connected",
    "Status Disconnected",
    "State Enabled",
    "State Disabled",
  ];
  // const filterMap = {connectionstate:"Status",enable:"State"};
  // const type = ["Meter","Release","Relay","Drives","Transmitter","Sensor","Other"];
  // const subtype = [["EM101","ER300P","Nova","PQ7000","PQ8000","Quasar","WC4400","WC4405","WC4410","WC4420","WC4430","WC4440","WC5000","WC5010","WC6000","WL4400","WL4405","WL4410","WL4420","WL4430","WL4440","WL5000","WL5010","WL6000","miEnergy1Ph","miEnergy3Ph"],["MTX30","MTX35","MTX35SEC","MTX45","SR71","iTrip4","iTrip5"],["MC61CnX","etaCON","etaULTRA","iMMR"],["CX2000","FX2000","HX2000","NX2000","NX2000Plus","SX2000"],["Pressure","Level"],["Flow","Temperature","Chlorine","pH"],[]];
  const meterType = ["Plant", "Consumer"];
  const phaseType = ["Single Phase", "Three Phase"];
  const deviceCategory = [
    ["Incomer", "Incomer"],
    ["Feeder", "Feeder"],
  ];

  const { theme } = useContext(ThemeContext);
  const dispatch = useDispatch();

  const userdetails = useSelector((state) => state.logindata.userdetails);
  const projectname = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );

  const [openForm, setOpenForm] = useState(0);
  const [saveStatus, setSaveStatus] = useState(0);
  const [deleteSuccess, setDeleteSuccess] = useState(0);
  const [loading, setLoading] = useState(1);
  const [required, setRequired] = useState(0);
  const [type, setType] = React.useState([]); // 0 is id, 1 is name
  const [subtype, setSubtype] = React.useState([]); // 0 is id, 1 is name
  const [unitandDatatype, setUnitandDatatype] = React.useState([]);
  const [storageGroups, setStorageGroups] = React.useState([]);
  const [deleteDeviceArr, setDeleteDeviceArr] = React.useState([]);
  const [deleteConfimed, setDeleteConfirmed] = React.useState(0);
  const [deleteDevice, setDeleteDevice] = React.useState(0);
  const [searchList, setsearchList] = React.useState([]);
  const [ifsearching, setifSearching] = useState(0);
  const [search, setSearch] = useState({ searchText: "" });
  const [deviceInfo, setDeviceInfo] = useState({
    organizationId: "",
    projectId: "",
    id: "",
    data: {
      deviceName: "",
      deviceType: "",
      deviceSubtype: "",
      meterType: meterType[0],
      otherDeviceType: "",
      phaseType: phaseType[0],
      finalReading: "",
      deviceCategory: "Feeder",
      make: "",
      model: "",
      firmware: "",
      enable: true,
      description: "",
      parameters: {},
    },
  });
  const [deviceno, setDeviceno] = useState([]); //list of devices
  const [disableButtons, setDisableButtons] = useState(99);
  //for disableButtons = 0, all buttons are enabled
  //for disableButtons = 99, all buttons are disabled
  //for disableButtons = 1, only delete button  and select all and close is enabled  ///search  what about search while deleting??
  //for disableButtons = 2, only save form and close form is enabled ?

  useEffect(() => {
    getDeviceTypesList(getDeviceTypesListcallback);
    // getlibrarydevices(getlibrarydevicescallback);
    getTagUnitsandDataTypes(getTagUnitsandDataTypescallback); //since its isprojrct independent once during loading is enough
    getStorageGroupsList(getStorageGroupsListcallback);
    setLoading(1);
  }, []);

  useEffect(() => {
    if (type.length !== 0) {
      getlibrarydevices(getlibrarydevicescallback);
      setLoading(1);
    }
  }, [type]);

  useEffect(() => {
    getDeviceTypesList(getDeviceTypesListcallback);
    // getlibrarydevices(getlibrarydevicescallback);
    getStorageGroupsList(getStorageGroupsListcallback);
    setLoading(1);
  }, [projectname]);

  // useEffect(()=>{
  //     if(deleteDeviceArr.length!==0 ){
  //         setDisableButtons(1);
  //     }
  //     else {
  //         if(disableButtons!==99){
  //             setDisableButtons(0);
  //         }
  //     }
  // },[deleteDeviceArr])

  function getDeviceTypesListcallback(res) {
    let temptype = [[], []];
    let tempsubtype = [[], []];
    if (res.status === 200) {
      if (res.data.type === "success") {
        if (res.data.data.length === 0) {
          // temptype=[[],[]]
          // tempsubtype = [[],[]]
        } else {
          res.data.data.map((val, index) => {
            temptype[0] = [...temptype[0], val.TypeID];
            let name = val.TypeName;
            if (name.charAt(0) === "_") {
              name = name.substring(1);
            }
            temptype[1] = [...temptype[1], name];
            tempsubtype[0] = [...tempsubtype[0], []];
            tempsubtype[1] = [...tempsubtype[1], []];
            val.SubTypeList.map((sval, sindex) => {
              tempsubtype[0][index] = [
                ...tempsubtype[0][index],
                sval.SubTypeID,
              ];
              let sname = sval.SubTypeName;
              if (sname.charAt(0) === "_") {
                sname = sname.substring(1);
              }
              tempsubtype[1][index] = [...tempsubtype[1][index], sname];
            });
          });
          setType(temptype);
          setSubtype(tempsubtype);
        }
      } else if (res.data.type === "error") {
        // handle error
      }
    } else if (res.status === 500) {
      // pop for error
    }
  }

  function getTagUnitsandDataTypescallback(res) {
    if (res.status === 200 && res.data.type === "success") {
      setUnitandDatatype(res.data.data);
    } else if (res.status === 500) {
      // pop for error
    }
  }

  function getStorageGroupsListcallback(res) {
    if (res.status === 200 && res.data.type === "success") {
      setStorageGroups(res.data.data);
    } else if (res.status === 500) {
      // pop for error
    }
    setLoading(0);
  }

  function alldevices(res) {
    let temp = [];
    let data;
    let meterid = "";
    // let metersubtypeid = '';
    let ismeter = 0;
    type[1].map((val, index) => {
      if (val === "Meter") {
        meterid = type[0][index];
        // metersubtypeid = subtype[0][index][0];
      }
    });
    res.map((_val, index) => {
      if (res[index].DeviceType.DeviceTypeID === meterid) {
        if (res[index].DeviceType.MeterType === "Consumer") {
          data = {
            organizationId: res[index].OrgID,
            projectId: res[index].ProjectID,
            id: res[index].DeviceID,
            data: {
              deviceName: res[index].Name,
              deviceType: res[index].DeviceType.DeviceTypeID,
              deviceSubtype: res[index].DeviceType.DeviceSubTypeID,
              meterType: res[index].DeviceType.MeterType,
              accuracyClass: res[index].DeviceType.AccuracyClass,
              phaseType: res[index].DeviceType.PhaseType,
              deviceCategory: res[index].Category,
              make: res[index].Make,
              model: res[index].Model,
              firmware: res[index].Firmware,
              enable: res[index].Enable,
              description: res[index].Description,
              parameters: res[index].Parameters,
            },
          };
        } else {
          data = {
            organizationId: res[index].OrgID,
            projectId: res[index].ProjectID,
            id: res[index].DeviceID,
            data: {
              deviceName: res[index].Name,
              serialNo: res[index].SN,
              deviceType: res[index].DeviceType.DeviceTypeID,
              deviceSubtype: res[index].DeviceType.DeviceSubTypeID,
              meterType: res[index].DeviceType.MeterType,
              phaseType: res[index].DeviceType.PhaseType,
              deviceCategory: res[index].Category,
              make: res[index].Make,
              model: res[index].Model,
              firmware: res[index].Firmware,
              enable: res[index].Enable,
              description: res[index].Description,
              parameters: res[index].Parameters,
            },
          };
        }
      } else {
        data = {
          organizationId: res[index].OrgID,
          projectId: res[index].ProjectID,
          id: res[index].DeviceID,
          data: {
            deviceName: res[index].Name,
            serialNo: res[index].SN,
            deviceType: res[index].DeviceType.DeviceTypeID,
            deviceSubtype: res[index].DeviceType.DeviceSubTypeID,
            deviceCategory: res[index].Category,
            make: res[index].Make,
            model: res[index].Model,
            firmware: res[index].Firmware,
            enable: res[index].Enable,
            description: res[index].Description,
            parameters: res[index].Parameters,
          },
        };
      }
      temp = [...temp, data];
    });
    return temp;
  }

  function getlibrarydevicescallback(res) {
    const data = alldevices(res);
    // dispatch(getdeviceno(data));
    setDeviceno(data);
    setLoading(0);
    setDisableButtons(0);
  }

  function handleToastClose() {
    setSaveStatus(0);
  }

  function handleDeleteToastClose() {
    setDeleteSuccess(0);
  }

  const handleCloseAddForm = () => {
    setOpenForm(0);
    setRequired(0);
    setSaveStatus(0);
    setDeviceInfo({
      organizationId: "",
      projectId: "",
      id: "",
      data: {
        deviceName: "",
        serialNo: "",
        deviceType: "",
        deviceSubtype: "",
        meterType: meterType[0],
        otherDeviceType: "",
        phaseType: phaseType[0],
        finalReading: "",
        deviceCategory: "Feeder",
        make: "",
        model: "",
        firmware: "",
        enable: true,
        description: "",
        commissionDate: "",
        calibrationDate: "",
        decommissionDate: "",
        associatedGateway: "none",
        parameters: {},
      },
    });
  };

  function validateDeviceName(deviceInfo) {
    let valiad = 1;
    if (deviceInfo.id === "") {
      for (let i = 0; i < deviceno.length; i++) {
        if (deviceno[i].data.deviceName.charAt(0) === "_") {
          if (
            deviceno[i].data.deviceName.substring(1) ===
            deviceInfo.data.deviceName
          ) {
            valiad = 0;
          }
        } else {
          if (deviceno[i].data.deviceName === deviceInfo.data.deviceName) {
            valiad = 0;
          }
        }
      }
    } else {
      valiad = 1;
    }
    return valiad;
  }

  const handleSaveAddForm = () => {
    if (
      deviceInfo.data.deviceName !== "" &&
      deviceInfo.data.make !== "" &&
      deviceInfo.data.model !== ""
    ) {
      setRequired(0);
      const validated = validateDeviceName(deviceInfo);
      if (validated) {
        if (deviceInfo.data.connectionState === "") {
          deviceInfo.data.connectionState = "";
        }
        let meterid = "";
        // let metersubtypeid = '';
        let ismeter = 0;
        type[1].map((val, index) => {
          if (val === "Meter") {
            meterid = type[0][index];
            // metersubtypeid = subtype[0][index][0];
          }
        });
        if (deviceInfo.data.deviceType === "") {
          deviceInfo.data.deviceType = type[0][0];
          deviceInfo.data.deviceSubtype = subtype[0][0][0];
        }
        if (deviceInfo.data.deviceType === meterid) {
          ismeter = 1;
        } else {
          deviceInfo.data.meterType = meterType[0];
          deviceInfo.data.phaseType = phaseType[0];
          deviceInfo.data.finalReading = "";
        }
        deviceInfo.organizationId = userdetails.Organizationid;
        deviceInfo.projectId = projectname;
        devicelibrarycreate(deviceInfo, ismeter, callback);
        setLoading(1);
        setDisableButtons(99);
      } else {
        setRequired(2);
      }
    } else {
      setOpenForm(1);
      setRequired(1);
    }
  };

  function callback(res) {
    if (res.status === 201) {
      let data;
      // //setdeviceno([...deviceno,deviceInfo]);
      let meterid = "";
      type[1].map((val, index) => {
        if (val === "Meter") {
          meterid = type[0][index];
        }
      });
      if (deviceInfo.data.deviceType === meterid) {
        if (deviceInfo.data.meterType === "Consumer") {
          data = {
            organizationId: deviceInfo.organizationId,
            projectId: deviceInfo.projectId,
            id: deviceInfo.id,
            data: {
              deviceName: deviceInfo.data.deviceName,
              deviceType: deviceInfo.data.deviceType,
              deviceSubtype: deviceInfo.data.deviceSubtype,
              meterType: deviceInfo.data.meterType,
              phaseType: deviceInfo.data.phaseType,
              deviceCategory: deviceInfo.data.deviceCategory,
              make: deviceInfo.data.make,
              model: deviceInfo.data.model,
              firmware: deviceInfo.data.firmware,
              enable: deviceInfo.data.enable,
              description: deviceInfo.data.description,
              parameters: deviceInfo.data.parameters,
            },
          };
        } else {
          data = {
            organizationId: deviceInfo.organizationId,
            projectId: deviceInfo.projectId,
            id: deviceInfo.id,
            data: {
              deviceName: deviceInfo.data.deviceName,
              deviceType: deviceInfo.data.deviceType,
              deviceSubtype: deviceInfo.data.deviceSubtype,
              meterType: deviceInfo.data.meterType,
              deviceCategory: deviceInfo.data.deviceCategory,
              phaseType: deviceInfo.data.phaseType,
              make: deviceInfo.data.make,
              model: deviceInfo.data.model,
              firmware: deviceInfo.data.firmware,
              enable: deviceInfo.data.enable,
              description: deviceInfo.data.description,
              parameters: deviceInfo.data.parameters,
            },
          };
        }
      } else {
        data = {
          organizationId: deviceInfo.organizationId,
          projectId: deviceInfo.projectId,
          id: deviceInfo.id,
          data: {
            deviceName: deviceInfo.data.deviceName,
            deviceType: deviceInfo.data.deviceType,
            deviceSubtype: deviceInfo.data.deviceSubtype,
            deviceCategory: deviceInfo.data.deviceCategory,
            make: deviceInfo.data.make,
            model: deviceInfo.data.model,
            firmware: deviceInfo.data.firmware,
            enable: deviceInfo.data.enable,
            description: deviceInfo.data.description,
            parameters: deviceInfo.data.parameters,
          },
        };
      }
      if (deviceInfo.id === "") {
        deviceInfo.id = res.data.deviceId;
        deviceInfo.data.parameters = res.data.tags;
        data.data.parameters = deviceInfo.data.parameters;
        data.id = deviceInfo.id;
        //dispatch(updatedeviceno(data));
        setDeviceno([...deviceno, data]);
      } else {
        deviceInfo.data.parameters = res.data.tags;
        data.data.parameters = deviceInfo.data.parameters;
        //dispatch(updatedevicedata(data));
        // setDeviceno(deviceno.map((val,index)=>(val.id===deviceInfo.id)?data:val)); ---??
        let arrindex = -1;
        deviceno.map((value, index) => {
          if (value.id == data.id) {
            arrindex = index;
          }
        });
        if (arrindex !== -1) {
          setDeviceno(
            deviceno.map((val, index) => (index === arrindex ? data : val)),
          );
        }
      }
      setSaveStatus(1);
    } else {
      setSaveStatus(2);
      //
    }
    setLoading(0);
    setDisableButtons(0);
  }

  function handleDeviceName(selectedValue) {
    deviceInfo.data.deviceName = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceMake(selectedValue) {
    deviceInfo.data.make = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceModel(selectedValue) {
    deviceInfo.data.model = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceFirmware(selectedValue) {
    deviceInfo.data.firmware = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceDescription(selectedValue) {
    deviceInfo.data.description = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceType(selectedValue) {
    deviceInfo.data.deviceType = selectedValue;
    setDeviceInfo(deviceInfo);
  }
  function handleDeviceSubtype(selectedValue) {
    deviceInfo.data.deviceSubtype = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceCategory(selectedValue) {
    deviceInfo.data.deviceCategory = selectedValue.target.value;
    setDeviceInfo(deviceInfo);
  }

  function handlePhaseType(selectedValue) {
    deviceInfo.data.phaseType = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleMeterType(selectedValue) {
    deviceInfo.data.meterType = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceEnable(selectedValue) {
    deviceInfo.data.enable = selectedValue;
    if (selectedValue === false) {
      deviceInfo.data.connectionState = "Disabled";
    }
    setDeviceInfo(deviceInfo);
  }

  function handleParameter(selectedValue) {
    const temp = Object.values(selectedValue); ///
    deviceInfo.data.parameters = temp;
    setDeviceInfo(deviceInfo);
  }

  function handleRefresh() {
    getDeviceTypesList(getDeviceTypesListcallback);
    // getdevices(getdevicescallback);
    setLoading(1);
    setDisableButtons(99);
  }

  function handleDeleteCancel() {
    setDeleteDeviceArr([]);
    setDeleteDevice(0);
    setDeleteConfirmed(0);
  }

  function handleSelectAllDevices() {
    let ids = [];
    if (ifsearching !== 1) {
      //incase of complete list
      //clear selected all
      if (
        deviceno.filter((val) => val.data.deviceName.charAt(0) !== "_")
          .length === deleteDeviceArr.length
      ) {
        setDeleteDeviceArr(ids);
      } else {
        //selects all
        deviceno.map((val) => {
          if (val.data.deviceName.charAt(0) !== "_") {
            ids = [...ids, val.id];
          }
        });
        setDeleteDeviceArr(ids);
      }
    } else {
      //in case of searched list
      ids = [...deleteDeviceArr];
      let searchlistlen = [];
      searchList.map((val) =>
        deleteDeviceArr.map((value) => {
          if (value === val.id && val.data.deviceName.charAt(0) !== "_") {
            searchlistlen = [...searchlistlen, val.id];
          }
        }),
      );
      //clear selected all
      if (
        searchlistlen.length ===
        searchList.filter((val) => val.data.deviceName.charAt(0) !== "_").length
      ) {
        searchlistlen.map((value) => {
          ids = ids.filter((val) => value !== val);
        });
        //temp.filter((val)=>(val!==props.gatewaylist.id)
        setDeleteDeviceArr(ids);
      } else {
        //selects all
        searchList.map((val) => {
          const ifpresent = ids.filter((value) => value === val.id);
          if (ifpresent.length === 0 && val.data.deviceName.charAt(0) !== "_") {
            ids = [...ids, val.id];
          }
        });
        setDeleteDeviceArr(ids);
      }
    }
  }

  function handleDeleteSelected() {
    if (deleteDeviceArr.length === 0) {
      setDeleteConfirmed(2);
    } else {
      setDeleteConfirmed(1);
    }
  }

  function handleDeleteConfirmed() {
    if (deleteDeviceArr.length > 0) {
      librarydevicedelete(deleteDeviceArr, deletioncallback);
      setDeleteConfirmed(0);
      setLoading(1);
    } else {
      //popup plz select device
    }
  }

  function deletioncallback(res, _id) {
    if (res.status === 200) {
      const temp = alldevices(res.data.devices);
      //dispatch(getdeviceno(temp));
      setDeviceno(temp);
      setDeleteDeviceArr([]);
      setDeleteDevice(0);
      setDeleteSuccess(1);
      setLoading(0);
    } else {
      setDeleteSuccess(2);
      setLoading(0);
    }
  }

  function handleSearchText(selectedValue) {
    search.searchText = selectedValue;
    setSearch(search);
  }

  function handleSearchCancel() {
    setSearch({ searchText: "", filterSelected: "" });
    setsearchList([]);
    setifSearching(0);
  }

  function handleSearchClick() {
    let temp = [];
    let templist = [...deviceno];
    // if(search.filterSelected!==""){
    //     const filterVal=Object.entries(filterMap).find(([_key, value]) => search.filterSelected.includes(value));
    //     setifSearching(1);
    //     let val="";
    //     //("Enabled" || "Connected")
    //     if(search.filterSelected.includes("Enabled")){
    //         val=true;
    //     }else if(search.filterSelected.includes("Disabled")){
    //         val=false;
    //     }
    //     deviceno.filter(value => {
    //         if(search.filterSelected.includes("Connected") || search.filterSelected.includes("Disconnected")){
    //             connState.map(val => {
    //                 if(val[0]===value.id && search.filterSelected.includes(val[1])){
    //                     temp=[...temp,value];
    //                 }
    //             })
    //         }
    //         else{
    //             Object.keys(value.data).forEach(key => {
    //                 if (key === filterVal[0] ) {
    //                     if(value.data[key] === val || value.data[key] === val.toString())
    //                         {
    //                             temp=[...temp,value];
    //                         }
    //                 }
    //             });
    //         }
    //         templist=[...temp];
    //     })
    // }
    if (search.searchText !== "") {
      setifSearching(1);
      temp = [];
      templist.filter((value) => {
        if (
          value.id.toLowerCase().includes(search.searchText.toLowerCase()) ||
          value.data.deviceName
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.description
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.deviceType.includes(search.searchText.toLowerCase()) ||
          value.data.make
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.model
            .toLowerCase()
            .includes(search.searchText.toLowerCase())
        ) {
          temp = [...temp, value];
        }
      });
    }
    setsearchList(temp);
  }

  const DeviceForm = (props) => {
    const [typeIndex, setTypeIndex] = React.useState(0);
    const [deviceDetails, setDeviceDetails] = React.useState(1);
    const [parameterDetails, setParameterDetails] = React.useState(0);
    const [connectionDetails, setConnectionDetails] = React.useState(1);
    const [meter, setMeter] = React.useState(type[1][0] === "Meter" ? 1 : 0);

    useEffect(() => {
      type[0].map((val, index) => {
        if (val === props.deviceData.data.deviceType) {
          setTypeIndex(index);
          if (type[1][index] === "Meter") {
            setMeter(1);
          } else {
            setMeter(0);
          }
        }
      });
    }, [props.deviceData]);

    function handleDeviceTypeF(selectedValue) {
      type[1].map((val, index) => {
        if (val === selectedValue) {
          setTypeIndex(index);
          handleDeviceType(type[0][index]);
        }
      });
      if (selectedValue === "Meter") {
        setMeter(1);
      } else {
        setMeter(0);
      }
    }

    function handleDeviceSubtypeF(selectedValue) {
      subtype[1][typeIndex].map((val, index) => {
        if (val === selectedValue) {
          handleDeviceSubtype(subtype[0][typeIndex][index]);
        }
      });
    }

    function handleDeleteTagsF(selected) {
      const temp = Object.values(selected);
      let id = -1;
      deviceno.map((val, index) => {
        if (val.id === deviceInfo.id) {
          id = index;
        }
      });
      if (id !== -1) {
        let data = { ...deviceno[id], data: { ...deviceno[id].data } };
        data.data.parameters = temp;
        // dispatch(updatedevicedata(data));
      }
      setDeleteSuccess(1);
    }

    function handletypename(deviceType) {
      let typeName = "";
      type[0].map((val, index) => {
        if (val === deviceType) {
          typeName = type[1][index];
        }
      });
      return typeName;
    }

    function handlesubtypename(deviceSubtype) {
      let subtypeName = subtype[1][typeIndex][0];
      subtype[0][typeIndex].map((val, index) => {
        if (val === deviceSubtype) {
          subtypeName = subtype[1][typeIndex][index];
        }
      });
      return subtypeName;
    }

    return (
      <Box sx={{ width: "100%", height: "100%" }}>
        <Box
          sx={{
            width: "100%",
            height: "7%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Typography
            style={{
              fontSize: "24px",
              fontWeight: 700,
              color: "#008CD7",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            {props.deviceData.id !== ""
              ? props.deviceData.data.deviceName.charAt(0) === "_"
                ? props.deviceData.data.deviceName.substring(1)
                : props.deviceData.data.deviceName
              : "Devices"}
          </Typography>
        </Box>
        <Box sx={{ width: "100%", height: "93%", overflow: "auto" }}>
          <Typography
            className="config-heading"
            style={{
              fontSize: "20px",
              fontWeight: 400,
              color: "#008CD7",
              padding: "4px",
              marginTop:
                "20px" /*backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'*/,
            }}
          >
            Device Details{" "}
            <Button
              onClick={() => {
                deviceDetails === 1 ? setDeviceDetails(0) : setDeviceDetails(1);
              }}
            >
              {deviceDetails === 1 ? (
                <ExpandLessOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              ) : (
                <ExpandMoreOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              )}
            </Button>
          </Typography>
          {deviceDetails === 1 ? (
            <Box
              style={{ overflow: "auto" }}
              sx={{
                display: "flex",
                gap: "0px",
                flexWrap: "wrap",
                padding: "4px 4px 12px 4px",
                backgroundColor: theme === "dark" ? "#3C3C3C40" : "#FFFFFF80",
              }}
            >
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Name
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomTextField
                  id={"negative-feedback"}
                  onChange={handleDeviceName}
                  disabled={props.deviceData.id !== "" ? true : false}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.deviceName.charAt(0) === "_"
                        ? props.deviceData.data.deviceName.substring(1)
                        : props.deviceData.data.deviceName
                      : deviceInfo.data.deviceName
                  }
                  maxLength={250}
                  width={224}
                  permittedCharacters={"^[a-zA-Z][a-zA-Z0-9_]*$"}
                  errorText={"Only alphanumeric characters are allowed"}
                />
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "66.66%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              ></Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Type
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomDropDown
                  options={type[1]}
                  onChange={handleDeviceTypeF}
                  /*disabled={props.deviceData.id!==""?true:false}*/ defaultValue={
                    props.deviceData.id !== ""
                      ? handletypename(props.deviceData.data.deviceType)
                      : type[1][typeIndex]
                  }
                ></CustomDropDown>
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device SubType
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomDropDown
                  options={subtype[1][typeIndex]}
                  onChange={handleDeviceSubtypeF}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? handlesubtypename(props.deviceData.data.deviceSubtype)
                      : subtype[1][typeIndex][0]
                  }
                ></CustomDropDown>
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Description
                </Typography>
                <CustomTextField
                  id={"negative-feedback"}
                  onChange={handleDeviceDescription}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.description
                      : deviceInfo.data.description
                  }
                  maxLength={250}
                  width={1297}
                />
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "66.66%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Level
                </Typography>{" "}
                {/*Category*/}
                <CustomRadioButton
                  row={true}
                  onChange={handleDeviceCategory}
                  options={deviceCategory}
                  fontSize={16}
                  width={"calc(100% - 224px)"}
                  optionWidth={282}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.deviceCategory
                      : deviceInfo.data.deviceCategory !== ""
                        ? deviceInfo.data.deviceCategory
                        : deviceCategory[1][1]
                  }
                />
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              ></Box>
              {meter === 1 ? (
                <>
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Meter Type
                      <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                    </Typography>
                    <CustomDropDown
                      options={meterType}
                      onChange={handleMeterType}
                      /*disabled={props.deviceData.id!==""?true:false}*/ defaultValue={
                        props.deviceData.id !== "" &&
                        props.deviceData.data.meterType !== undefined
                          ? props.deviceData.data.meterType
                          : meterType[0]
                      }
                    ></CustomDropDown>
                  </Box>
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Phase Type
                      <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                    </Typography>
                    <CustomDropDown
                      options={phaseType}
                      onChange={handlePhaseType}
                      /*disabled={props.deviceData.id!==""?true:false}*/ defaultValue={
                        props.deviceData.id !== "" &&
                        props.deviceData.data.phaseType !== undefined
                          ? props.deviceData.data.phaseType
                          : phaseType[0]
                      }
                    ></CustomDropDown>
                  </Box>
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  ></Box>
                </>
              ) : (
                <></>
              )}
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Make
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomTextField
                  id={"negative-feedback"}
                  onChange={handleDeviceMake}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.make
                      : deviceInfo.data.make
                  }
                  maxLength={250}
                  width={224}
                />
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Model
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomTextField
                  id={"negative-feedback"}
                  onChange={handleDeviceModel}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.model
                      : deviceInfo.data.model
                  }
                  maxLength={250}
                  width={224}
                />
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Firmware
                </Typography>
                <CustomTextField
                  id={"negative-feedback"}
                  onChange={handleDeviceFirmware}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.firmware
                      : deviceInfo.data.firmware
                  }
                  maxLength={250}
                  width={224}
                />
              </Box>
            </Box>
          ) : (
            <></>
          )}
          <Typography
            className="config-heading"
            style={{
              fontSize: "20px",
              fontWeight: 400,
              color: "#008CD7",
              padding: "4px",
              marginTop: "20px",
            }}
          >
            Connection Details
            <Button
              onClick={() => {
                connectionDetails === 1
                  ? setConnectionDetails(0)
                  : setConnectionDetails(1);
              }}
            >
              {connectionDetails === 1 ? (
                <ExpandLessOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              ) : (
                <ExpandMoreOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              )}
            </Button>
          </Typography>
          {connectionDetails === 1 ? (
            <Box
              style={{ overflow: "auto" }}
              sx={{
                display: "flex",
                gap: "0px",
                flexWrap: "wrap",
                padding: "4px 4px 12px 4px",
                backgroundColor: theme === "dark" ? "#3C3C3C40" : "#FFFFFF80",
              }}
            >
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Box
                  className="config-form-box"
                  style={{ gap: 0, marginTop: 0 }}
                >
                  <Box style={{ marginTop: "-2.05px" }}>
                    <CustomCheckbox
                      defaultChecked={
                        props.deviceData.id !== ""
                          ? props.deviceData.data.enable
                          : deviceInfo.data.enable
                      }
                      onChange={handleDeviceEnable}
                    ></CustomCheckbox>
                  </Box>
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      width: "224px",
                      marginLeft: "8px",
                    }}
                  >
                    {" "}
                    Enable Device
                  </Typography>
                </Box>
              </Box>
            </Box>
          ) : (
            <></>
          )}
          <Typography
            className="config-heading"
            style={{
              fontSize: "20px",
              fontWeight: 400,
              color: "#008CD7",
              padding: "4px",
              marginTop: "20px",
            }}
          >
            Parameter Details
            <Button
              onClick={() => {
                parameterDetails === 1
                  ? setParameterDetails(0)
                  : setParameterDetails(1);
              }}
            >
              {parameterDetails === 1 ? (
                <ExpandLessOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              ) : (
                <ExpandMoreOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              )}
            </Button>
          </Typography>
          {parameterDetails === 1 ? (
            <Box
              style={{ width: "100%", boxSizing: "border-box", height: "auto" }}
            >
              <EditableTableLibrary
                data={
                  props.deviceData.data.parameters.length > 0
                    ? props.deviceData.data.parameters
                    : []
                }
                setdata={handleParameter}
                deviceId={props.deviceData.id}
                enabled={props.deviceData.data.enable}
                getdeleteTags={handleDeleteTagsF}
                units={unitandDatatype.unitsList}
                datatypes={unitandDatatype.dataTypesList}
                storageGroupsList={storageGroups}
              />
            </Box>
          ) : (
            <></>
          )}
        </Box>
      </Box>
    );
  };

  function handleCloneParameter(para) {
    const updatedParameters = para.map((param, i) => ({
      ...param,
      tagId: "", // Set tagid to an empty string
      key: i.toString(), // Add a unique key for each parameter
    }));
    return updatedParameters;
  }

  function handleClone(event) {
    const temp = deviceno[event.target.id];
    let data;
    let meterid = "";
    type[1].map((val, index) => {
      if (val === "Meter") {
        meterid = type[0][index];
      }
    });
    if (temp.data.deviceType === meterid) {
      if (temp.data.meterType === "Consumer") {
        data = {
          organizationId: temp.organizationId,
          projectId: temp.projectId,
          id: "",
          data: {
            deviceName: temp.data.deviceName,
            deviceType: temp.data.deviceType,
            deviceSubtype: temp.data.deviceSubtype,
            meterType: temp.data.meterType,
            accuracyClass: temp.data.accuracyClass,
            phaseType: temp.data.phaseType,
            deviceCategory: temp.data.deviceCategory,
            make: temp.data.make,
            model: temp.data.model,
            firmware: temp.data.firmware,
            enable: temp.data.enable,
            description: temp.data.description,
          },
        };
      } else {
        data = {
          organizationId: temp.organizationId,
          projectId: temp.projectId,
          id: "",
          data: {
            deviceName: temp.data.deviceName,
            deviceType: temp.data.deviceType,
            deviceSubtype: temp.data.deviceSubtype,
            meterType: temp.data.meterType,
            deviceCategory: temp.data.deviceCategory,
            phaseType: temp.data.phaseType,
            make: temp.data.make,
            model: temp.data.model,
            firmware: temp.data.firmware,
            enable: temp.data.enable,
            description: temp.data.description,
          },
        };
      }
    } else if (temp.data.deviceType === "Other") {
      data = {
        organizationId: temp.organizationId,
        projectId: temp.projectId,
        id: "",
        data: {
          deviceName: temp.data.deviceName,
          deviceType: temp.data.deviceType,
          deviceSubtype: temp.data.deviceSubtype,
          deviceCategory: temp.data.deviceCategory,
          make: temp.data.make,
          model: temp.data.model,
          firmware: temp.data.firmware,
          enable: temp.data.enable,
          description: temp.data.description,
        },
      };
    } else {
      data = {
        organizationId: temp.organizationId,
        projectId: temp.projectId,
        id: "",
        data: {
          deviceName: temp.data.deviceName,
          deviceType: temp.data.deviceType,
          deviceSubtype: temp.data.deviceSubtype,
          deviceCategory: temp.data.deviceCategory,
          make: temp.data.make,
          model: temp.data.model,
          firmware: temp.data.firmware,
          enable: temp.data.enable,
          description: temp.data.description,
        },
      };
    }
    data.data.deviceName =
      (data.data.deviceName.charAt(0) === "_"
        ? data.data.deviceName.substring(1)
        : data.data.deviceName) + "_clone";
    data.data.parameters = temp.data.parameters
      ? handleCloneParameter(temp.data.parameters)
      : [];
    setDeviceInfo(data);
    setOpenForm(true);
  }

  const DeviceCard = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleDeviceCardMore = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
      setAnchorEl(null);
    };

    const handleDeviceEdit = () => {
      const temp = props.devicelist;
      let data;
      let meterid = "";
      type[1].map((val, index) => {
        if (val === "Meter") {
          meterid = type[0][index];
        }
      });
      if (temp.data.deviceType === meterid) {
        if (temp.data.meterType === "Consumer") {
          data = {
            organizationId: temp.organizationId,
            projectId: temp.projectId,
            id: temp.id,
            data: {
              deviceName: temp.data.deviceName,
              deviceType: temp.data.deviceType,
              deviceSubtype: temp.data.deviceSubtype,
              meterType: temp.data.meterType,
              accuracyClass: temp.data.accuracyClass,
              phaseType: temp.data.phaseType,
              deviceCategory: temp.data.deviceCategory,
              make: temp.data.make,
              model: temp.data.model,
              firmware: temp.data.firmware,
              enable: temp.data.enable,
              description: temp.data.description,
              parameters: temp.data.parameters,
            },
          };
        } else {
          data = {
            organizationId: temp.organizationId,
            projectId: temp.projectId,
            id: temp.id,
            data: {
              deviceName: temp.data.deviceName,
              deviceType: temp.data.deviceType,
              deviceSubtype: temp.data.deviceSubtype,
              meterType: temp.data.meterType,
              deviceCategory: temp.data.deviceCategory,
              phaseType: temp.data.phaseType,
              make: temp.data.make,
              model: temp.data.model,
              firmware: temp.data.firmware,
              enable: temp.data.enable,
              description: temp.data.description,
              parameters: temp.data.parameters,
            },
          };
        }
      } else if (temp.data.deviceType === "Other") {
        data = {
          organizationId: temp.organizationId,
          projectId: temp.projectId,
          id: temp.id,
          data: {
            deviceName: temp.data.deviceName,
            deviceType: temp.data.deviceType,
            deviceSubtype: temp.data.deviceSubtype,
            deviceCategory: temp.data.deviceCategory,
            make: temp.data.make,
            model: temp.data.model,
            firmware: temp.data.firmware,
            enable: temp.data.enable,
            description: temp.data.description,
            parameters: temp.data.parameters,
          },
        };
      } else {
        data = {
          organizationId: temp.organizationId,
          projectId: temp.projectId,
          id: temp.id,
          data: {
            deviceName: temp.data.deviceName,
            deviceType: temp.data.deviceType,
            deviceSubtype: temp.data.deviceSubtype,
            deviceCategory: temp.data.deviceCategory,
            make: temp.data.make,
            model: temp.data.model,
            firmware: temp.data.firmware,
            enable: temp.data.enable,
            description: temp.data.description,
            parameters: temp.data.parameters,
          },
        };
      }
      setDeviceInfo(data);
      setOpenForm(1);
    };

    function handleDeleteCheck(selected) {
      const temp = [...deleteDeviceArr];
      if (selected === true) {
        temp.push(props.devicelist.id);
        setDeleteDeviceArr(temp);
        //temp=[...temp,props.index]
      } else {
        setDeleteDeviceArr(temp.filter((val) => val !== props.devicelist.id));
      }
    }

    useEffect(() => {
      if (deleteDevice === 2) {
      }
    }, [deleteDevice]);

    function handletypename(deviceType) {
      let typeName = "";
      type[0].map((val, index) => {
        if (val === deviceType) {
          typeName = type[1][index];
        }
      });
      return typeName;
    }

    function handlesubtypename(deviceType, deviceSubtype) {
      let typeIndex = 0;
      type[0].map((val, index) => {
        if (val === deviceType) {
          typeIndex = index;
        }
      });
      let subtypeName = subtype[1][typeIndex][0];
      subtype[0][typeIndex].map((val, index) => {
        if (val === deviceSubtype) {
          subtypeName = subtype[1][typeIndex][index];
        }
      });
      return subtypeName;
    }

    return (
      <Box
        key={props.index}
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "125px",
          width: "calc(25% - 6px)",
          minWidth: "300px" /*394.5px */,
          textAlign: "left",
          boxSizing: "border-box",
          overflowWrap: "break-word",
        }}
      >
        <Box
          key={props.index}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            background: "var(--SecondaryBackground)",
            padding: "10px 10px 10px 10px",
            textAlign: "left",
            boxSizing: "border-box",
            overflowWrap: "break-word",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              gap: "4px",
            }}
          >
            <Box sx={{ marginTop: "-2.58px", marginRight: "4px" }}>
              <CustomCheckbox
                style={{ Padding: 0 }}
                disabled={
                  props.devicelist.data.deviceName.charAt(0) === "_"
                    ? true
                    : false
                }
                defaultChecked={
                  deleteDeviceArr.includes(props.devicelist.id) === true
                    ? true
                    : false
                }
                onChange={handleDeleteCheck}
                width={15}
                height={15}
              />
            </Box>
            {/* <CustomTooltip title={props.devicelist.data.deviceName} offset={[30,-20]} placement={'right-end'}> */}
            <Typography
              sx={{
                fontFamily: "Roboto",
                fontSize: "20px",
                fontWeight: "700",
                color: "var(--PrimaryText)",
                marginTop: "-4px",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {props.devicelist.data.deviceName.charAt(0) === "_"
                ? props.devicelist.data.deviceName.substring(1)
                : props.devicelist.data.deviceName}
            </Typography>
            {/* </CustomTooltip> */}
            <Box style={{ flexGrow: 1 }}></Box>
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleDeviceCardMore}
              disabled={disableButtons !== 0 ? true : false}
              style={{
                postion: "inline",
                height: "19px",
                maxWidth: "16px",
                minWidth: "16px",
                fontSize: "12px",
                fontWeight: "700",
                color:
                  disableButtons !== 0
                    ? theme === "light"
                      ? "#C1C1C1"
                      : "#3C3C3C"
                    : "var(--PrimaryText)",
                textTransform: "none",
                padding: 0,
                margin: 0,
              }}
            >
              <MoreVertIcon sx={{ height: "20px", width: "20px" }} />
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleCloseMenu}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              PaperProps={{
                component: "form",
                sx: {
                  borderRadius: 0,
                  bgcolor: theme === "dark" ? "#000000" : "#FFFFFF",
                  maxHeight: "150px",
                  maxWidth: "150px",
                  width: "120px",
                  height: "89px",
                  overflow: "auto",
                  color: theme === "dark" ? "#C1C1C1" : "#7E7E7E",
                  padding: "0px 0px 0px 0px",
                },
              }}
              style={{
                "::-webkit-scrollbar-track": {
                  background: "#000000",
                },
              }}
              sx={{
                "&.MuiList-root MuiList-padding MuiMenu-list": {
                  padding: "0px 0px 0px 0px",
                },
              }}
            >
              <MenuItem onClick={handleDeviceEdit} id={props.index}>
                Edit
              </MenuItem>
              {/* <Divider variant="middle" style={{margin:"0px 2px 0px 2px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                            <MenuItem onClick={handlelibraryDeviceDelete} id={props.index}>Delete</MenuItem> */}
              <Divider
                variant="middle"
                style={{
                  margin: "0px 2px 0px 2px",
                  background: theme === "dark" ? "#3C3C3C" : "#EFEFEF",
                }}
              />
              <MenuItem onClick={handleClone} id={props.index}>
                Clone Device
              </MenuItem>
              {/* <Divider variant="middle" style={{margin:"0px 2px 0px 2px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                            <MenuItem onClick={()=>setOpen1(true)}  id={props.index}>dailog</MenuItem> */}
              {/* <MenuItem onClick={() =>  navigator.clipboard.writeText(props.devicelist.data.primaryConnectionString)}  id={props.index}>Copy String</MenuItem> */}
            </Menu>
            {/* <CustomDialogBox dialogTitle={"hi"} dialogText={"hi"} openDialog={open1} handleCloseDialog={()=>setOpen1(false)} handleConfirmDialog={()=>setOpen1(false)} confirmText={"hi"} cancelText={"hi"}/> */}
            {/* <DeviceForm /*formType={"Edit"} index={props.index} openForm={openEditForm}* closeForm={handleCloseEditForm} saveForm={handleSaveEditForm} deviceData={deviceData}/> */}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "calc(100% - 8px)",
              fontFamily: "Roboto",
              margin: "0px 0px 0px 0px",
              boxSizing: "border-box",
              gap: "16px",
            }}
          >
            <Typography
              className="config-heading"
              style={{
                fontSize: "16px",
                fontWeight: 400,
                color: "var(--PrimaryText)",
                lineHeight: "28px",
                width: "50%",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              Device Type: {handletypename(props.devicelist.data.deviceType)}
            </Typography>
            <Typography
              className="config-heading"
              style={{
                fontSize: "16px",
                fontWeight: 400,
                color: "var(--PrimaryText)",
                lineHeight: "28px",
                width: "50%",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              Device SubType:{" "}
              {handlesubtypename(
                props.devicelist.data.deviceType,
                props.devicelist.data.deviceSubtype,
              )}
            </Typography>
          </Box>
          <Typography
            className="config-heading"
            style={{
              fontSize: "16px",
              fontWeight: 700,
              color: "var(--PrimaryText)",
              marginRight: "24px",
              marginTop: "8px",
            }}
          >
            Description
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              fontSize: "16px",
              fontFamily: "Roboto",
              margin: "0px 0px 12px 0px",
              flexWrap: "wrap",
            }}
          >
            <Typography
              className="config-heading"
              style={{
                fontSize: "16px",
                fontWeight: 400,
                color: "var(--PrimaryText)",
                marginRight: "20px",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {props.devicelist.data.description !== ""
                ? props.devicelist.data.description
                : "-"}
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <Box
      className="compliance-config"
      sx={{ height: "100%", boxSizing: "border-box", width: "100%" }}
    >
      {saveStatus !== 0 ? (
        <CustomToast
          openToast={saveStatus !== 0}
          type={saveStatus === 1 ? "Success" : "Error"}
          autoHideDuration={10000}
          toastText={saveStatus === 1 ? "Saved Successfully!" : "Save Failed"}
          onClose={handleToastClose}
        />
      ) : (
        <></>
      )}
      {deleteSuccess !== 0 ? (
        <CustomToast
          openToast={deleteSuccess !== 0}
          type={deleteSuccess === 1 ? "Success" : "Error"}
          toastText={
            deleteSuccess === 1 ? "Deleted Successfully!" : "Delete Failed"
          }
          onClose={handleDeleteToastClose}
        />
      ) : (
        <></>
      )}
      <Box
        sx={{
          padding: "0px",
          height: "calc(100% - 0px)",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            padding: "0px",
            width: "100%",
            height: "7%",
            boxSizing: "border-box",
            display: "flex",
          }}
        >
          {openForm === 0 ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  margin: "0px",
                  alignSelf: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    fontSize: "16px",
                    fontFamily: "Roboto",
                    margin: "0px",
                    alignSelf: "center",
                  }}
                >
                  <Typography
                    className="config-heading"
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: "var(--GreyVariation_4)",
                      marginRight: "12px",
                      alignContent: "end",
                    }}
                  >
                    Total
                  </Typography>
                  <Typography
                    className="config-heading"
                    style={{
                      fontSize: "20px",
                      fontWeight: 400,
                      color: "var(--PrimaryText)",
                      marginRight: "40px",
                    }}
                  >
                    {deviceno.length}
                  </Typography>
                </Box>
                <Box
                  sx={{ flexGrow: 1, height: "24px", alignSelf: "center" }}
                ></Box>
                <CustomTooltip
                  title={"Refresh"}
                  offset={[30, -20]}
                  placement={"right-end"}
                >
                  <Button
                    onClick={handleRefresh}
                    disabled={disableButtons !== 0 ? true : false}
                    sx={{
                      width: "40px",
                      "& .MuiButtonBase-root.MuiButton-root": { width: "40px" },
                      padding: 0,
                    }}
                    style={{
                      fontSize: "12px",
                      height: "28px",
                      minWidth: "44px",
                      width: "40px",
                      fontWeight: 400,
                      alignSelf: "center",
                      marginLeft: "auto",
                      marginRight: "auto",
                      marginTop: "-8px",
                    }}
                  >
                    <LK_Refresh
                      color={
                        disableButtons !== 0
                          ? theme === "light"
                            ? "#C1C1C1"
                            : "#3C3C3C"
                          : "var(--LK_BrandBlue)"
                      }
                      width={"28px"}
                      height={"28px"}
                    />
                  </Button>
                </CustomTooltip>
                <CustomTooltip
                  title={"Add"}
                  offset={[30, -20]}
                  placement={"right-end"}
                >
                  <Button
                    onClick={() => setOpenForm(1)}
                    disabled={disableButtons !== 0 ? true : false}
                    sx={{
                      width: "40px",
                      "& .MuiButtonBase-root.MuiButton-root": { width: "40px" },
                      padding: 0,
                    }}
                    style={{
                      fontSize: "12px",
                      height: "28px",
                      width: "40px",
                      minWidth: "44px",
                      fontWeight: 400,
                      alignSelf: "center",
                      marginLeft: "auto",
                      marginRight: "auto",
                      marginTop: "-8px",
                    }}
                  >
                    <LK_Add
                      color={
                        disableButtons !== 0
                          ? theme === "light"
                            ? "#C1C1C1"
                            : "#3C3C3C"
                          : "var(--LK_BrandBlue)"
                      }
                      width={"28px"}
                      height={"28px"}
                    />
                  </Button>
                </CustomTooltip>
                <CustomTooltip
                  title={"Select All"}
                  offset={[30, -20]}
                  placement={"right-end"}
                >
                  <Button
                    onClick={handleSelectAllDevices}
                    disabled={
                      disableButtons !== 0 && disableButtons !== 1
                        ? true
                        : false
                    }
                    style={{
                      fontSize: "12px",
                      height: "40px",
                      width: "40px",
                      minWidth: "40px",
                      fontWeight: 400,
                      alignSelf: "center",
                      marginLeft: "-0px",
                      marginRight: "0",
                      marginTop: "-8px",
                    }}
                  >
                    <LK_Select
                      color={
                        disableButtons !== 0 && disableButtons !== 1
                          ? theme === "light"
                            ? "#C1C1C1"
                            : "#3C3C3C"
                          : "var(--LK_BrandBlue)"
                      }
                      width={"36px"}
                      height={"36px"}
                    />
                  </Button>
                </CustomTooltip>
                <CustomTooltip
                  title={"Delete"}
                  offset={[30, -20]}
                  placement={"right-end"}
                >
                  <Button
                    onClick={handleDeleteSelected}
                    disabled={
                      disableButtons !== 0 && disableButtons !== 1
                        ? true
                        : false
                    }
                    sx={{
                      width: "40px",
                      "& .MuiButtonBase-root.MuiButton-root": { width: "40px" },
                      padding: 0,
                    }}
                    style={{
                      fontSize: "12px",
                      height: "36px",
                      width: "36px",
                      minWidth: "36px",
                      boxSizing: "border-box",
                      fontWeight: 400,
                      alignSelf: "center",
                      marginLeft: "-4px",
                      marginRight: "0",
                      marginTop: "-8px",
                    }}
                  >
                    <LK_Delete
                      color={
                        disableButtons !== 0 && disableButtons !== 1
                          ? theme === "light"
                            ? "#C1C1C1"
                            : "#3C3C3C"
                          : "var(--LK_BrandBlue)"
                      }
                      width={"36px"}
                      height={"36px"}
                    />
                  </Button>
                </CustomTooltip>
                <CustomDialogBox
                  dialogTitle={"Delete Conformation"}
                  dialogText={
                    "Are you sure you want to delete " +
                    deleteDeviceArr.length +
                    " device" +
                    (deleteDeviceArr.length > 1 ? "s" : "")
                  }
                  openDialog={deleteConfimed === 1}
                  handleCloseDialog={handleDeleteCancel}
                  handleConfirmDialog={handleDeleteConfirmed}
                  confirmText={"OK"}
                  cancelText={"Cancel"}
                  type={"Warning"}
                />
                <CustomDialogBox
                  dialogTitle={"Delete Conformation"}
                  dialogText={"Please select devices for deletion"}
                  openDialog={deleteConfimed === 2}
                  handleCloseDialog={handleDeleteCancel}
                  handleConfirmDialog={() => {
                    setDeleteConfirmed(0);
                  }}
                  confirmText={"OK"}
                  cancelText={"Cancel"}
                  type={"Warning"}
                />
                <CustomTooltip
                  title={"Deselect All"}
                  offset={[30, -20]}
                  placement={"right-end"}
                >
                  <Button
                    onClick={handleDeleteCancel}
                    disabled={
                      disableButtons !== 0 && disableButtons !== 1
                        ? true
                        : false
                    }
                    style={{
                      fontSize: "12px",
                      height: "28px",
                      width: "40px",
                      minWidth: "44px",
                      fontWeight: 400,
                      alignSelf: "center",
                      marginLeft: "-6px",
                      marginRight: "0",
                      marginTop: "-8px",
                    }}
                  >
                    <LK_Close
                      color={
                        disableButtons !== 0 && disableButtons !== 1
                          ? theme === "light"
                            ? "#C1C1C1"
                            : "#3C3C3C"
                          : "var(--LK_BrandBlue)"
                      }
                      width={"24px"}
                      height={"24px"}
                    />
                  </Button>
                </CustomTooltip>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "16%",
                    fontSize: "16px",
                    fontFamily: "Roboto",
                    marginTop: "-4px",
                    alignSelf: "center",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <CustomTextField
                    id={"negative-feedback"}
                    onChange={handleSearchText}
                    disabled={
                      disableButtons !== 0 && disableButtons !== 1
                        ? true
                        : false
                    }
                    defaultValue={ifsearching === 0 ? "" : search.searchText}
                    placeholder={"search"}
                    width={180}
                  />
                  <CustomTooltip
                    title={"Search"}
                    offset={[30, -20]}
                    placement={"right-end"}
                  >
                    <Button
                      onClick={handleSearchClick}
                      style={{
                        fontSize: "12px",
                        width: "40px",
                        minWidth: "40px",
                        fontWeight: 400,
                        color: "var(--Searchtext_muted)",
                        fontFamily: "Roboto",
                        textAlign: "left",
                        justifySelf: "right",
                        cursor: "pointer",
                        textTransform: "none",
                        marginLeft: "0px",
                        padding: 0,
                      }}
                    >
                      <LK_Search
                        color={
                          disableButtons !== 0 && disableButtons !== 1
                            ? theme === "light"
                              ? "#C1C1C1"
                              : "#3C3C3C"
                            : "var(--LK_BrandBlue)"
                        }
                        width={"28px"}
                        height={"28px"}
                      />
                    </Button>
                  </CustomTooltip>
                  {ifsearching === 1 ? (
                    <Button
                      onClick={handleSearchCancel}
                      style={{
                        fontSize: "12px",
                        width: "34px",
                        minWidth: "34px",
                        fontWeight: 400,
                        color: "var(--Searchtext_muted)",
                        fontFamily: "Roboto",
                        textAlign: "left",
                        justifySelf: "right",
                        cursor: "pointer",
                        textTransform: "none",
                        marginLeft: "-8px",
                        padding: 0,
                      }}
                    >
                      <LK_Close
                        color={
                          disableButtons !== 0 && disableButtons !== 1
                            ? theme === "light"
                              ? "#C1C1C1"
                              : "#3C3C3C"
                            : "var(--LK_BrandBlue)"
                        }
                        width={"24px"}
                        height={"24px"}
                      />
                    </Button>
                  ) : (
                    <></>
                  )}
                </Box>
              </Box>
            </>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  gap: "8px",
                  width: "100%",
                  height: "100%",
                }}
              >
                <Box sx={{ flexGrow: 1 }}></Box>
                <CustomDialogBox
                  dialogTitle={"Required fields not filled"}
                  dialogText={"Required fields to must be filled"}
                  openDialog={required === 1}
                  handleCloseDialog={() => setRequired(0)}
                  handleConfirmDialog={() => setRequired(0)}
                  confirmText={"OK"}
                  cancelText={"Cancel"}
                  type={"Warning"}
                />
                <CustomDialogBox
                  dialogTitle={"Device name already in use"}
                  dialogText={"This device name is already in use"}
                  openDialog={required === 2}
                  handleCloseDialog={() => setRequired(0)}
                  handleConfirmDialog={() => setRequired(0)}
                  confirmText={"OK"}
                  cancelText={"Cancel"}
                  type={"Warning"}
                />
                <CustomCancelButton
                  onClick={handleCloseAddForm}
                  buttonText={"Cancel"}
                ></CustomCancelButton>
                <CustomButton
                  id={deviceInfo.id}
                  onClick={handleSaveAddForm}
                  buttonText={"Save"}
                  disabled={
                    deviceInfo.data.deviceName.charAt(0) === "_" ? true : false
                  }
                  width={"12px"}
                />
              </Box>
            </>
          )}
        </Box>
        <Box
          sx={{
            boxSizing: "border-box",
            padding: "8px",
            background: "var(--PrimaryBackground)",
            height: "calc(93%)",
            marginBottom: "0px",
            overflow: "auto",
          }}
        >
          {loading === 0 ? (
            <>
              {openForm === 0 ? (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "8px",
                      flexWrap: "wrap",
                      boxSizing: "border-box",
                      height: "calc(100%)",
                      overflow: "auto",
                      alignContent: "flex-start",
                    }}
                  >
                    {ifsearching === 0 ? (
                      <>
                        {deviceno.map((val, index) => (
                          <>
                            <DeviceCard index={index} devicelist={val} />
                          </>
                        ))}
                      </>
                    ) : (
                      <>
                        {searchList.length === 0 ? (
                          <>
                            <Typography
                              className="config-heading"
                              style={{
                                fontSize: "40px",
                                fontWeight: 700,
                                color: "var(--GreyBaseColor)",
                                marginRight: "20px",
                                justifySelf: "flex-end",
                                justifyItems: "center",
                                justifyContent: "center",
                                justifyTracks: "center",
                              }}
                            >
                              No Match Found
                            </Typography>
                          </>
                        ) : (
                          <>
                            {searchList.map((val, index) => (
                              <DeviceCard index={index} devicelist={val} />
                            ))}
                          </>
                        )}
                      </>
                    )}
                  </Box>
                </>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    gap: "8px",
                    flexWrap: "wrap",
                    height: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <DeviceForm
                    closeForm={handleCloseAddForm}
                    saveForm={handleSaveAddForm}
                    deviceData={deviceInfo}
                  />
                </Box>
              )}
            </>
          ) : (
            <>
              <Box
                sx={{
                  gap: "8px",
                  boxSizing: "border-box",
                  height: "calc(100%)",
                  width: "100%",
                  overflow: "auto",
                  alignContent: "center",
                }}
              >
                <img
                  src={LK_Loading}
                  alt="loading..."
                  style={{ height: "15%", width: "auto", alignSelf: "center" }}
                />
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
